import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// DASHBOARD APIS
// ================================

// 🔹 DASHBOARD STATS
export async function dashboardStats(review_user) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("dashboardStats error:", error);
    return { status: false, type: "danger", success: "Stats load failed" };
  }
}

// 🔹 REVIEW GROWTH
export async function reviewGrowth(review_user) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/review-growth`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("reviewGrowth error:", error);
    return { status: false, type: "danger", success: "Growth load failed" };
  }
}

// 🔹 RATING DISTRIBUTION
export async function ratingDistribution(review_user) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/rating-distribution`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("ratingDistribution error:", error);
    return { status: false, type: "danger", success: "Rating data failed" };
  }
}

// 🔹 PLATFORM PERFORMANCE
export async function platformPerformance(review_user) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/platform-performance`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("platformPerformance error:", error);
    return { status: false, type: "danger", success: "Platform data failed" };
  }
}

// 🔹 SENTIMENT TREND
export async function sentimentTrend(review_user) {
  try {
    const fd = new FormData();
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);
    fd.append("review_user", review_user);

    const response = await axios.post(`${apiBaseUrl}dashboard/sentiment-trend`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("sentimentTrend error:", error);
    return { status: false, type: "danger", success: "Sentiment trend failed" };
  }
}

// 🔹 RECENT REVIEWS
export async function recentReviews(review_user) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/recent-reviews`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("recentReviews error:", error);
    return { status: false, type: "danger", success: "Reviews load failed" };
  }
}

export async function getSentimentTrd(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}dashboard/sentiment-trands`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    console.error("recentReviews error:", error);
    return { status: false, type: "danger", success: "Reviews load failed" };
  }
}

export const sendAiReplay = async (
  ai_msg,
  review_id
) => {

  try {

    const fd = new FormData();

    fd.append("ai_msg", ai_msg);
    fd.append("review_id", review_id);

    const response = await axios.post(
      apiBaseUrl + "campaignapis/send_ai_replay",
      fd
    );

    return response.data;

  } catch (error) {

    console.error("getCampaignInvites error:", error);

    return {
      status: false,
      invites: [],
      total: 0
    };
  }
};